import { Role } from "../commons/models/role";
import { linksRoles } from "../linksRoles";

export interface Link {
	path: string[];
	icon: string;
	label: string;
	requiredRoles?: Role[][];
	allowed?: boolean;
}

export const getLinks = (userRoles: Role[]): Link[] => [
	{
		path: ['/contexts'],
		icon: 'explore',
		label: 'navbar.menu.contexts',
		requiredRoles: linksRoles.contexts
	},
	{
		path: ['/translations'],
		icon: 'translate',
		label: 'navbar.menu.translation',
		requiredRoles: linksRoles.translations
	},
	// {
	// 	path: ['/sequences'],
	// 	icon: 'sequence',
	// 	label: 'navbar.menu.sequences',
	// },
	{
		path: ['/offline-flags'],
		icon: 'power_settings_new',
		label: 'navbar.menu.offline',
		requiredRoles: linksRoles.offlineFlags
	},
	{
		path: ['/payment-config'],
		icon: 'monetization_on',
		label: 'navbar.menu.payment-config',
		requiredRoles: linksRoles.paymentConfig
	},
	{
		path: ['/timers'],
		icon: 'timer',
		label: 'navbar.menu.timers',
		requiredRoles: linksRoles.timers
	},
	{
		path: ['/faq'],
		icon: 'contact_support',
		label: 'navbar.menu.faq',
		requiredRoles: linksRoles.faq
	},
	{
		path: ['/contact'],
		icon: 'contact_mail',
		label: 'navbar.menu.contact',
		requiredRoles: linksRoles.contact
	},
	{
		path: ['/csat'],
		icon: 'star_half',
		label: 'navbar.menu.csat',
		requiredRoles: linksRoles.csat
	},
  {
		path: ['/templates'],
		icon: 'email',
		label: 'navbar.menu.templatesEmail',
		requiredRoles: linksRoles.emailsTemplates
	},
	{
		path: ['/sellers'],
		icon: 'corporate_fare',
		label: 'navbar.menu.seller',
		requiredRoles: linksRoles.seller
	},
  {
		path: ['/partners'],
		icon: 'diversity_3',
		label: 'navbar.menu.partner',
		requiredRoles: linksRoles.partner
	},
  {
		path: ['/origins'],
		icon: 'join_right',
		label: 'navbar.menu.origin',
		requiredRoles: linksRoles.origin
	}
].filter((link) => {
	if (!link.requiredRoles) return true;
	for (let roles of link.requiredRoles) {
		if (roles.every(role => userRoles.includes(role))) return true;
	}
	return false;
});
